<div class="space-for-scroll bg-neutral-0 flex h-full flex-col">
  <div class="flex flex-1 flex-col justify-center py-4">
    <div class="small:w-[360px] small:mx-auto flex h-full min-h-0 flex-col justify-center">
      <div class="flex flex-col">
        <h2 class="text-display-md small:mb-8 mb-5 text-center font-medium text-neutral-950">
          {{ 'examdojo.registration.create_account' | transloco }}
        </h2>
        <dojo-button [fill]="'outline'" (click)="loginWithGoogleProvider()">
          <ion-img class="h-5 w-5" src="./assets/images/google-logo.png" />
          <span class="ml-3">{{ 'examdojo.registration.sign_up_with' | transloco: { provider: 'Google' } }}</span>
        </dojo-button>
        <dojo-button [fill]="'outline'" class="mt-3" (click)="loginWithDiscordProvider()">
          <ion-img class="h-5 w-5" src="./assets/images/discord-logo.svg" />
          <span class="ml-3">{{ 'examdojo.registration.sign_up_with' | transloco: { provider: 'Discord' } }}</span>
        </dojo-button>
        <span
          class="small:my-6 relative my-3 text-center font-semibold uppercase text-neutral-400 after:absolute after:left-0 after:top-[50%] after:h-px after:w-full after:bg-neutral-200 after:content-['']"
        >
          <span class="z-1 bg-neutral-0 relative px-2">or sign up with email</span>
        </span>
        <form [formGroup]="form" class="flex w-full flex-col" autocomplete="off">
          <div class="mb-4 grid grid-cols-2 gap-4">
            <y42-text-input
              label="First name"
              [formCtrl]="form.controls.firstName"
              [errorMessages]="{
                required: 'First name is required'
              }"
            />

            <y42-text-input
              label="Last name"
              [formCtrl]="form.controls.lastName"
              [errorMessages]="{
                required: 'Last name is required'
              }"
            />
          </div>

          <y42-text-input
            class="mb-4"
            [label]="'Email'"
            [type]="'email'"
            [formCtrl]="form.controls.email"
            [errorMessages]="{
              required: 'Email is required',
              exists: 'Email already exists',
              api: 'Could not create account',
              email: 'Enter a valid email'
            }"
          />
          <y42-user-password-input [formCtrl]="form.controls.password" class="mb-6" [label]="'Password'" />

          @if (error) {
            <mat-error class="mb-4">
              {{ error }}
            </mat-error>
          }
          <dojo-button submitButton [confirmFn]="confirmFn" [attr.data-test]="'register-button-create-account'">
            Create account
          </dojo-button>
        </form>
        <div
          class="mt-6 text-center text-xs font-normal text-neutral-700"
          [innerHTML]="
            'examdojo.registration.sign_up_terms_and_conditions'
              | transloco
                : {
                    tac_url: 'https://examdojo.com/legal/terms-and-conditions',
                    privacy_policy_url: 'https://examdojo.com/legal/privacy-policy'
                  }
          "
        ></div>
        <div class="mt-4 flex items-center justify-center gap-4 text-center text-sm font-normal">
          {{ 'examdojo.registration.already_have_an_account' | transloco }}
          <a class="ml-1 flex items-center gap-1 font-medium text-sky-600 hover:text-sky-800" [routerLink]="loginUrl">
            <span>{{ 'examdojo.registration.sign_in' | transloco }}</span>
            <dojo-icon [icon]="'arrow-right'"></dojo-icon>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
